import all_tab from './img/all_tab.svg';
import participate_tab from './img/participate_tab.svg';
import not_participate_tab from './img/not-participate_tab.svg';
import { TabsGreyBtn } from '../../components/TabsGreyBtn/TabsGreyBtn';
import { CardDiscount } from '../../components/CardsComponents/CardDiscount/CardDiscount';
import { useParams, useLocation } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import { OlegActionsHttps } from '../../fetchUrls';
import {
  TableBox,
  Tabs,
  ButtonBasic
} from '@lk-gtcom/ecomlab-components';
import useGeneralStore from '../../store/general';
import './JoinedPromotions.scss';
import customHeaders, { getSpace } from '../../common/headers';
import FilePromotionModal from '../../components/Modal/FilePromotionModal/FilePromotionModal';
import { getValueMultiFilter } from '../../common/filtersFunc';
import { FilterArticles } from '../../components/FilterArticles/FilterArticles';
import { useDataTable } from '../../common/hooks';
import { usePushNotifications } from '../../common/pushNotification';

const btn_tab = [
  {
    label: 'Все',
    value: 'all',
    icon: all_tab,
  },
  {
    label: 'Участвуют',
    value: 'participate',
    icon: participate_tab,
  },
  {
    label: 'Не участвуют',
    value: 'not_participate',
    icon: not_participate_tab,
  },
];

const discounts = [
  {
    label: 'Все',
    value: null,
  },
  {
    label: '0 %',
    value: '0',
  },
  {
    label: '0-5 %',
    value: '0_5',
  },
  {
    label: '5-10 %',
    value: '5_10',
  },
  {
    label: '10-15%',
    value: '10_15',
  },
  {
    label: '15% и более',
    value: '15',
  },
];

const MAX_FILES_PER_DAY = 1;

const JoinedPromotions = ({
  selectedApi,
  selectedCategory,
  selectedBrand,
  selectedAction,
  check,
  isTableRequest,
  setIsTableRequest,
  isReady
}) => {
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  const location = useLocation();

  // Обработка ошибок
  const { addErrorPush, addSuccessPush, addWarningPush } = usePushNotifications();
  // Рефы
  const fileInputRef = useRef(null);

  const [pageValue, setPageValue] = useState('all');
  const [checkedProducts, setCheckedProducts] = useState([]);
  const [productAction, setProductAction] = useState(false);
  const [metricsData, setMetricsData] = useState([]);
  const [currentDiscount, setCurrentDiscount] = useState(discounts[0].value);
  const activeTab = useParams()['*'];

  const [filterValue, setFilterValue] = useState([]);

  // Таблица
  const paginatorRef = useRef();
  const [setTable, tableProps, setTableFuncs] = useDataTable(
    paginatorRef.current?.setTotal,
    paginatorRef
  );
  const { setLoading, setFetchedData, setHeaders, setSort } = setTableFuncs;
  const { total, loading } = tableProps;
  const [tableUrl, setTableUrl] = useState('');
  const [tableBody, setTableBody] = useState(null);
  const [isPromoModalOpen, setIsPromoModalOpen] = useState(false);
  const [loadingUpload, setLoadingUpload] = useState(false)

  useEffect(() => {
    setPageValue(activeTab);
    setCheckedProducts([]);
  }, [activeTab]);

  useEffect(() => {
    setCheckedProducts([]);
  }, [pageValue]);

  useEffect(() => {
    paginatorRef.current?.reset();
    setIsTableRequest(!isTableRequest)
  }, [pageValue, currentDiscount]);

  useEffect(() => {
    if (!isReady) return;
    setCheckedProducts([]);
    // paginatorRef.current?.reset();
    const abortController = new AbortController();
    fetchTable([], abortController);
    fetchMetrics(abortController);
    return () => abortController.abort();
  }, [isTableRequest, check, filterValue]);


  // Таблица
  const fetchTable = (params = [], abortController) => {
    if (selectedApi?.value) {
      setLoading(true);
      let sort, filters;
      if (params) {
        [sort, filters] = params;
      }
      setCheckedProducts([]);
      const url = `https://apps0.ecomru.ru:4420/api/v1/marketing/action/product/table${sort?.length > 0
        ? '?order_param=' + sort[0] + '&order_param_direction=' + sort[1]
        : ''}`;

      let current_status = btn_tab.find((el) => el?.value === pageValue)?.value || '';
      let filtersOffer = filterValue;

      const body = JSON.stringify({
        discount: currentDiscount,
        category_id_list: getValueMultiFilter(selectedCategory),
        brand_id_list: getValueMultiFilter(selectedBrand),
        api_id_list: selectedApi?.value ? [selectedApi?.value] : [],
        status: current_status === 'all' ? null : current_status,
        page: paginatorRef.current?.page,
        limit: paginatorRef.current?.limit,
        filters,
        offer_id_list: filtersOffer,
        action_id_list: selectedAction?.map((el) => String(el?.value)),
        order_param: sort?.[0],
        order_param_direction: sort?.[1],
        with_stock: check,
      });

      fetch(url, { body, method: 'POST', headers, signal: abortController?.signal })
        .then(async (res) => {
          if (res.ok) {
            return res.json();
          } else {
            const err = await res.json();
            throw new Error(JSON.stringify(err));
          }
        })
        .then((json) => {
          setTable(json);
          setTableUrl(json?.tableUrl);
          setTableBody(json?.tableBody);
        })
        .catch((err) => console.error(err))
        .finally(() => {
          if (abortController?.signal.aborted) return
          setLoading(false)
        })
    }
  };

  const fetchMetrics = (abortController) => {
    setMetricsData([]);
    discounts.forEach((discount) => {
      if (discount?.value) {
        fetchBlock(discount, abortController)
      }
    })
  };


  // Карточки метрик
  const fetchBlock = (discount, abortController = new AbortController().signal) => {
    if (selectedApi) {
      const { label, value } = discount;
      const url = `https://apps0.ecomru.ru:4420/api/v1/marketing/action/product/block`;

      const body = JSON.stringify({
        category_id_list: getValueMultiFilter(selectedCategory),
        brand_id_list: getValueMultiFilter(selectedBrand),
        api_id_list: selectedApi?.value ? [selectedApi?.value] : [],
        discount: value,
        action_id_list: getValueMultiFilter(selectedAction),
        with_stock: check,
      });

      fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
        .then((res) => res.json())
        .then((json) => {
          const { labels, data } = json;
          const { header } = labels;
          const dataObj = { value, data, header, title: label };
          // setMetricsData((prev) => [...prev, dataObj]);
          setMetricsData((prev) => {
            if (!prev.some((item) => item.value === value)) {
              return [...prev, dataObj];
            }
            return prev;
          });
        })
        .catch((err) => console.error(err))
        .finally(() => {
          if (abortController.signal.aborted) {
            return;
          }
        });
    }
  };

  const onProductAction = (json) => {
    setCheckedProducts([]);
    setProductAction(false)
  };

  const onAddAllProductToAction = () => {
    if (selectedApi) {
      const url = `${OlegActionsHttps}/api/v2/promotion/all/add`;
      setProductAction(true);
      const body = JSON.stringify({
        discount: currentDiscount || '0',
        category_id_list: getValueMultiFilter(selectedCategory),
        brand_id_list: getValueMultiFilter(selectedBrand),
        api_id_list: selectedApi?.value ? [selectedApi?.value] : [],
        action_id_list: getValueMultiFilter(selectedAction),
        with_stock: check,
      });

      fetch(url, {
        body,
        method: 'POST',
        headers,
      })
        .then((res) => {
          if (!res.ok) {
            addSuccessPush(`Ошибка добавления`)
            throw new Error('Network response was not ok');
          } else {
            return res.json();
          }
        })
        .then((json) => {
          onProductAction(json);
          setTimeout(() => fetchGetStatus(json?.detail, 'добавления в акции'), 1500)
        })
        .catch((err) => {
          console.error(err);
          addSuccessPush(`Ошибка добавления`)
        });
      // .finally(() => setLoading(false));
    }
  };

  const onRemoveAllProductFromAction = () => {
    if (
      selectedApi?.length ||
      selectedBrand?.length ||
      selectedCategory?.length
    ) {
      const url = `${OlegActionsHttps}/api/v2/promotion/all/remove`;
      setProductAction(true);

      const body = JSON.stringify({
        discount: currentDiscount || '0',
        category_id_list: getValueMultiFilter(selectedCategory),
        brand_id_list: getValueMultiFilter(selectedBrand),
        api_id_list: selectedApi?.value ? [selectedApi?.value] : [],
        action_id_list: getValueMultiFilter(selectedAction),
        with_stock: check,
      });

      fetch(url, {
        body,
        method: 'POST',
        headers,
      })
        .then((res) => res.json())
        .then((json) => {
          onProductAction(json);
          setTimeout(() => fetchGetStatus(json?.detail, 'удаления из акций'), 1500)
        })
        .catch((err) => console.error(err));
      // .finally(() => setLoading(false));
    }
  };

  const onAddProductToAction = () => {
    if (selectedApi) {
      const url = `${OlegActionsHttps}/api/v2/promotion/add`;
      setProductAction(true);

      let actionsObj = {};

      checkedProducts?.forEach((el) => {
        const { product_id, action_id, api_id } = el;
        const action_price = el?.max_action_price;

        if (!actionsObj[api_id]) {
          actionsObj[api_id] = [];
        }

        const existingAction = actionsObj[api_id].find(
          (action) => action.action_id === action_id
        );
        if (existingAction) {
          existingAction.products.push({ action_price, product_id });
        } else {
          actionsObj[api_id].push({
            action_id,
            products: [{ action_price, product_id }],
          });
        }
      });

      const apiIds = Object.keys(actionsObj);

      if (apiIds.length > 0) {
        const body = JSON.stringify({
          api_id: apiIds[0],
          actions: actionsObj[apiIds[0]],
        });

        fetch(url, {
          body,
          method: 'POST',
          headers,
        })
          .then((res) => {
            if (!res.ok) {
              addSuccessPush(`Ошибка добавления`)
              throw new Error('Network response was not ok');
            } else {
              return res.json();
            }
          })
          .then((json) => {
            onProductAction(json);
            // addSuccessPush(`Добавленные успешно ${json?.success?.length}, не удалось добавить ${json?.rejected?.length}`);
            setTimeout(() => fetchGetStatus(json?.detail, 'добавления в акции'), 1500)
          })
          .catch((err) => {
            console.error('Error:', err);
            addSuccessPush(`Ошибка добавления`)
          });
      } else {
        // setLoading(false);
      }
    }
  };

  const onRemoveProductFromAction = () => {
    if (selectedApi) {
      const url = `${OlegActionsHttps}/api/v2/promotion/remove`;
      setProductAction(true);

      let actionsObj = {};
      checkedProducts?.forEach((el) => {
        const { product_id, action_id, api_id } = el;
        const productIdStr = String(product_id);

        if (!actionsObj[api_id]) {
          actionsObj[api_id] = {};
        }

        if (actionsObj[api_id][action_id]) {
          actionsObj[api_id][action_id].push(productIdStr);
        } else {
          actionsObj[api_id][action_id] = [productIdStr];
        }
      });

      const body = {
        api_id: String(Object.keys(actionsObj)[0]),
        actions: Object.keys(actionsObj[Object.keys(actionsObj)[0]]).map(
          (action_id) => ({
            action_id: String(action_id),
            products: actionsObj[Object.keys(actionsObj)[0]][action_id],
          })
        ),
      };

      fetch(url, {
        method: 'POST',
        headers,
        body: JSON.stringify(body),
      })
        .then((res) => {
          if (!res.ok) {
            throw new Error('Network response was not ok');
          }
          return res.json();
        })
        .then((json) => {
          onProductAction(json);
          setTimeout(() => fetchGetStatus(json?.detail, 'удаления из акций'), 1500)
        })
        .catch((err) => console.error(err));
      // .finally(() => setLoading(false));
    }
  };

  // Статус

  const fetchGetStatus = (taskId, status = 'добавления в акции') => {
    const url = `https://apps1.ecomru.ru:4448/api/v2/promotion/status/${taskId}`;

    fetch(url, { method: 'GET', headers })
      .then((res) => {
        if (!res.ok) {
          addSuccessPush(`Ошибка добавления`)
          throw new Error('Network response was not ok');
        } else {
          return res.json();
        }
      })
      .then((json) => {
        console.log(json?.status)
        if (json?.status === 'FAILURE') {
          addSuccessPush(`Статус ${status} - "Ошибка"`);
        } else if (json?.status === 'SUCCESS') {
          addSuccessPush(`Статус ${status} - "Успешно"`);
          setIsTableRequest(!isTableRequest)
        } else {
          addSuccessPush(`Статус ${status} - "В РАБОТЕ"`);
          // setTimeout(() => fetchGetStatus(), 2000);
        }
      })
      .catch((err) => {
        console.error(err);
        addSuccessPush(`Ошибка добавления`)
      });
    // .finally(() => setLoading(false));
  }


  const [fileId, setFileId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const incrementUploadCount = () => {
    const today = new Date().toISOString().split('T')[0];
    const uploadData = JSON.parse(localStorage.getItem('fileUploadData')) || {};
    const updatedData = {
      date: today,
      count: (uploadData.count || 0) + 1,
    };

    localStorage.setItem('fileUploadData', JSON.stringify(updatedData));
  };

  const checkUploadLimit = () => {
    const today = new Date().toISOString().split('T')[0];
    const uploadData = JSON.parse(localStorage.getItem('fileUploadData')) || {};

    if (uploadData.date !== today) {
      localStorage.setItem(
        'fileUploadData',
        JSON.stringify({ date: today, count: 0 })
      );
      return true;
    }

    return uploadData.count < MAX_FILES_PER_DAY;
  };

  const onAddFileClick = () => {
    if (!checkUploadLimit()) {
      addErrorPush('Вы можете загрузить только один файл в день.');
      return;
    }
    setIsPromoModalOpen(true);
  };

  const onUploadFileToPromotion = (file) => {
    if (!file) {
      return;
    }

    setLoadingUpload(true)
    addWarningPush('Дождитесь окончания загрузки, после завершения процесса  появится уведомление')
    setIsLoading(true);

    const url = `${OlegActionsHttps}/api/v2/promotion/file/upload`;

    const formData = new FormData();
    formData.append('file', file);

    const updatedHeaders = { ...headers };
    delete updatedHeaders['Content-Type'];

    fetch(url, {
      method: 'POST',
      updatedHeaders,
      headers: updatedHeaders,
      body: formData,
    })
      .then(async (res) => {
        const data = await res.json(); // парсим ответ один раз
        if (!res.ok) {
          const errorMessage = data.detail;
          addErrorPush(`Ошибка загрузки: ${errorMessage}`);
          throw new Error(`Upload failed: ${res.statusText}`);
        }
        return data;
      })
      .then((data) => {
        incrementUploadCount();
        setFileId(data);
        addSuccessPush('Файл успешно загружен')
        if (fileInputRef.current) fileInputRef.current.value = ''
      })
      .catch((err) => {
        console.error(err);
        if (fileInputRef.current) fileInputRef.current.value = ''
      })
      .finally(() => {
        setIsLoading(false)
        setLoadingUpload(false)
      });
  };

  const onAddAllFileProductsToPromotion = () => {
    if (!fileId) return;

    const url = `${OlegActionsHttps}/api/v1/promotion/file/all/add`;

    const body = JSON.stringify({
      file_id: fileId?.file_id,
    });

    fetch(url, { method: 'POST', headers, body })
      .then((res) => {
        if (!res.ok) {
          return res.json().then((error) => {
            throw new Error(
              `Add all products failed: ${error.detail || res.statusText}`
            );
          });
        }
        return res.json();
      })
      .then((data) => {
        addSuccessPush();
      })
      .catch((err) => {
        console.error(err);
        addErrorPush();
      });
  };

  const onRemoveFileFromPromotion = () => {
    if (!fileId) return;

    const url = `${OlegActionsHttps}/api/v2/promotion/file/remove/${fileId?.file_id}`;

    fetch(url, {
      method: 'POST',
      headers,
    })
      .then((res) => {
        if (!res.ok) {
          return res.json().then((error) => {
            throw new Error(`Remove failed: ${error.detail || res.statusText}`);
          });
        }
        return res.json();
      })
      .then((data) => {
        console.log(data);
      })
      .catch((err) => {
        console.error(err);
        addErrorPush();
      });
  };

  return (
    <div className="joined-promotions">
      {isPromoModalOpen && (
        <FilePromotionModal
          fileId={fileId?.file_id}
          isLoading={isLoading}
          onClose={() => setIsPromoModalOpen(false)}
          onUploadFile={onUploadFileToPromotion}
          onAddProducts={onAddAllFileProductsToPromotion}
          onRemoveFile={onRemoveFileFromPromotion}
          onAddProductToAction={onAddProductToAction}
          setCheckedProducts={setCheckedProducts}
          setIsPromoModalOpen={setIsPromoModalOpen}
        />
      )}

      <section className="joined-promotions__metrics">
        {metricsData.length > 0
          ? metricsData
            .sort((a, b) => {
              const aArr = a?.value?.split('_');
              const bArr = b?.value?.split('_');
              const sortRes = aArr[aArr?.length - 1] - bArr[bArr?.length - 1];
              if (sortRes === 0) {
                return bArr?.length - aArr?.length;
              }
              return sortRes;
            })
            .map((el, i) => (
              <CardDiscount
                key={i + el.title}
                header={el.header}
                data={el.data}
                title={el.title}
                period=""
                loading={null}
              />
            ))
          : [...Array(5)].map((_, i) => (
            <CardDiscount
              key={i}
              data={[]}
              title=""
              period="7"
              loading={null}
            />
          ))}
      </section>

      <Tabs
        tabs={btn_tab}
        pageValue={pageValue}
        query={location?.search}
      />

      <TableBox
        {...tableProps}
        ref={paginatorRef}
        tableUrl={tableUrl}
        tableBody={JSON.stringify(tableBody)}
        tableHeaders={headers}
        paginator={true}
        fetchCallback={fetchTable}
        onCheck={(e) => {
          setCheckedProducts(e);
        }}
        onUncheckAllDependence={[pageValue, currentDiscount, productAction]}
        child={
          <>
            <TabsGreyBtn
              title="Скидка"
              btns={discounts}
              currentBtn={currentDiscount}
              setCurrentBtn={(e) => setCurrentDiscount(e)}
              checkValue={true}
            />

            {pageValue !== 'all' && (
              <>
                <ButtonBasic
                  action
                  text={
                    pageValue !== 'participate' ? 'Добавить все' : 'Убрать все'
                  }
                  size="32px"
                  maxWidth="140px"
                  width="140px"
                  onClick={() =>
                    pageValue !== 'participate'
                      ? onAddAllProductToAction()
                      : onRemoveAllProductFromAction()
                  }
                />
                <ButtonBasic
                  action
                  width="180px"
                  maxWidth="180px"
                  text={
                    pageValue !== 'participate'
                      ? 'Добавить выбранные'
                      : 'Убрать выбранные'
                  }
                  size="32px"
                  disabled={!checkedProducts.length}
                  onClick={() =>
                    pageValue !== 'participate'
                      ? onAddProductToAction()
                      : onRemoveProductFromAction()
                  }
                />
              </>
            )}

            <ButtonBasic
              width="auto"
              text={`Добавить товары из файла`}
              size="32px"
              onClick={(e) =>
                // setIsPromoModalOpen(true);
                onAddFileClick()
              }
            />

            <FilterArticles
              filterValue={filterValue}
              setFilterValue={setFilterValue}
            />
          </>
        }
      />
    </div>
  );
};

export { JoinedPromotions };
